module.exports = __webpack_public_path__ + "assets/images/abeldo_bd66dca03bc50b305e0166fde3822043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dialog-ballons/profiles/abeldo.png
// module id = 138
// module chunks = 0